<script setup lang="ts">
import OpenEye from 'assets/icons/eye-open.svg';
import CloseEye from 'assets/icons/eye-close.svg';

const password = defineModel<string>('password', { default: '' });

defineProps<{
  placeholder: string;
  passwordError: boolean;
}>();

const { t } = useI18n();

const passwordIsVisible = ref(false);
const passwordType = computed(() => (passwordIsVisible.value ? 'text' : 'password'));

const emit = defineEmits<{
  (e: 'focusout'): void;
  (e: 'change'): void;
  (e: 'input'): void;
}>();

const inputRef = ref<HTMLInputElement | undefined>(undefined);
defineExpose({ input: inputRef });
</script>

<template>
  <div class="relative">
    <TextInput
      ref="inputRef"
      v-model="password"
      :type="passwordType"
      :placeholder="placeholder"
      minlength="8"
      pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@#\{\}\[\]+\-=~_<>\|$!%*?&\(\).])[A-Za-z\d!#^*@#\{\}\[\]+\-=~_<>\|$!%*?&\(\).]{8,}$"
      :is-error="passwordError"
      autocomplete="password"
      @focusout="emit('focusout', $event)"
      @change="emit('change', $event)"
      @input="emit('input', $event)"
    />

    <OpenEye
      v-if="passwordIsVisible"
      class="absolute right-4 top-[13px]"
      :class="{
        'text-red-500': passwordError,
      }"
      @click="passwordIsVisible = !passwordIsVisible"
    />

    <CloseEye
      v-if="!passwordIsVisible"
      :class="{
        'text-red-500': passwordError,
      }"
      class="absolute right-4 top-[13px]"
      @click="passwordIsVisible = !passwordIsVisible"
    />
  </div>
</template>

<style scoped>

</style>
